import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useCallback } from 'react';
import { TrackingFrom, useTrackingLocation } from './useTrackingLocation';

export const useNavigateWithTracking = () => {
  const navigate = useNavigate();
  const location = useTrackingLocation();

  const navigateWithTracking = useCallback(
    (
      url: string,
      trackingFrom?: TrackingFrom,
      options?: Omit<NavigateOptions, 'state'> & { state?: Record<string, unknown> }
    ) => {
      navigate(url, {
        ...options,
        state: { ...(trackingFrom ?? location), ...options?.state },
      });
    },
    []
  );

  return navigateWithTracking;
};
